import { createActions } from "redux-actions";

export const {
  getDocumentsList,
  setDocumentsList,
  downloadDocument,
  documentListError
} = createActions(
  "GET_DOCUMENTS_LIST",
  "SET_DOCUMENTS_LIST",
  "DOWNLOAD_DOCUMENT",
  "DOCUMENT_LIST_ERROR"
);
